export const PACS_CONTENTS_NAMES ={
  PACS : {
    selectserver:'Select Server',
    pacsconfig:'PACS Config',
    patientname:'Patient Name',
    patientid:'Patient ID',
    birthdate:'Birth Date',
    accessionnumber:'Accession Number',
    description:'Description',
    referringphysician:'Referring Physician',
    studyid:'Study ID',
    studydate:'Study Date',
    modality:'Modality',
    modalities:{
      allmodality:'All Modality',
      cr:'CR',
      pt:'PT',
      xc:'XC'
    },
    clear:'Clear',
    query:'Query',
    close:'Close',
    download:'Download',
    pacsstudylist:'PACS Study List',
    pacserieslist:'PACS Series List'
  }
}
